<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="fund-settlement">
      <Title jpn="Act on Payment service" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="Operating company name"
        >
          <div class="text-container">
            <span class="text">Iranoan Co., Ltd.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="Representative responsible person"
        >
          <div class="text-container">
            <span class="text">Nao Suzuki</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="Company registration address/Business office address"
        >
          <div class="text-container">
            <span class="text">〒330-0856</span>
            <span class="text">2-800-18 Mitsuhashi, Omiya Ward, Saitama City, Saitama Prefecture</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="Points (currency in this site) Possession Limit and Expiration Date"
        >
          <div class="text-container left">
            <span class="text">There is no maximum number of points.</span>
            <span class="text">However, if 6 months (including the day) have passed since the last use date without using points from point purchase or point exchange, the account can be deleted without prior notice to the customer.</span>
            <span class="text">In this case, the points will expire.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="Range of locations where points can be used"
        >
          <div class="text-container left">
            <span class="text">There is no maximum number of points.</span>
            <span class="text">Points (in-site currency) can be used within your registered account.</span>
            <span class="text">In addition, transfer of account and transfer of points are prohibited.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="Precautions for use"
        >
          <div class="text-container left">
            <span class="text">Points (in-site currency) cannot be refunded.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="How to check owned points"
        >
          <div class="text-container left">
            <span class="text">You can check it on the screen of this site.</span>
            <span class="text">If there is movement in the owned points, the number there will change automatically.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="Contact information"
        >
          <div class="text-container left">
            <span class="text">Please contact us through one of the two options below.</span>
            <span class="text">
              <a href="https://minny-online-store.iranoan.com/contacts?service=1" target="_blank">"inquiry form" at minny mail order store</a>
              , TEL: 050-3552-5876 for phone calls.<br>
            </span>
            <span class="text">※Reception hours are from 10:00 to 17:00 on weekdays</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="Terms of service"
        >
          <div class="text-container">
            <span class="text">Please check the terms of use of this site.</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title.vue';
import t from '@/plugins/i18n';

export default {
  name: 'FundSettlement',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.fund-settlement{
  width: 100%;
  max-width: 1000px;
  min-height: 100%;
  padding: 30px 20px 0px;
  margin: 0px auto;
  color: $white;
  @include appendMap($backgroundStyleMap);
  .fund-settlement-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0px 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          color: $white;
          a {
            color: $white!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
@media screen and  (max-width: $tabletWidth) {
  .left {
    text-align: left!important;
  }
}
</style>
